import { BrowserModule } from '@angular/platform-browser';
import { NgModule, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './components/app-root/app.component';
import { AppRoutingModule } from './modules/app-routing/app-routing.module';
import { RoutePlannerModule } from './modules/route-planner/route-planner.module';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { HeaderComponent } from './components/app-header/header.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { AAGoogleMapModule } from './modules/google-map/aa-google-map.module';
import { TrafficNewsModule } from './modules/traffic-news/traffic-news.module';
import { BreadcrumbsComponent } from './components/app-breadcrumbs/breadcrumbs.component';
import { AboutSectionComponent } from './components/about-section/about-section.component';
import { CarModelsSectionComponent } from './components/car-models-section/car-models-section.component';
import { SmartCareSectionComponent } from './components/smart-care-section/smart-care-section.component';
import { AACoreModule } from './modules/aa-core/aa-core.module';
import { MapsHotelsModule } from './modules/maps-hotels/maps-hotels.module';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { MerchandisingComponent } from './components/merchandising/merchandising.component';
import { SafeHtmlPipe } from './shared/pipes/safe-html/safe-html.pipe';
import { Subject } from 'rxjs';

export const googleMapInitializer = () => {
  const wait = new Subject();
  if (!document.getElementById('google-maps-aa')) {
    let googleKey = 'AIzaSyAeIm_flmJtYVeL7np4UaIiCM7H3Scft_8';
    if (window.location.hostname === 'www.theaa.com') {
      googleKey = 'AIzaSyAjqhFVkTluDG3Quby7hLNYsi_r3FIGKnI';
    }
    const script = document.createElement('script');
    script.id = 'google-maps-aa';
    script.src = `//maps.googleapis.com/maps/api/js?v=quarterly&libraries=places&key=${googleKey}&callback=initMap`;
    script.type = 'text/javascript';

    script.async = true;
    script.defer = true;

    globalThis.window['initMap'] = () => {
      wait.next();
      wait.complete();
      console.timeLog('map')
    };
    document.head.appendChild(script);
  }
  return wait.asObservable();
};
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    PageNotFoundComponent,
    AppFooterComponent,
    BreadcrumbsComponent,
    AboutSectionComponent,
    CarModelsSectionComponent,
    SmartCareSectionComponent,
    MerchandisingComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AAGoogleMapModule,
    AppRoutingModule,
    RoutePlannerModule,
    TrafficNewsModule,
    MapsHotelsModule,
    AACoreModule,
    NgbAlertModule,
    SafeHtmlPipe
  ],
  providers: [
    provideAppInitializer(googleMapInitializer),
     provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule {}
